<!--
	Existing signs body of the Interventions Signs section: one toggle for the signs, their speed
	plaques and the chevron-run outlines, drawn with the plain (unhaloed) sign icon.
-->
<script lang="ts">
	import LegendIcon from '#lib/components/LegendIcon.svelte';
	import DataNotAvailable from '#lib/components/DataNotAvailable.svelte';
	import SpriteIcon from '#lib/components/map/legend/SpriteIcon.svelte';
	import LegendItems from '../../legends/LegendItems.svelte';
	import { legendStore } from '#lib/stores/legendStore.svelte.js';
	import { geodataStore } from '#lib/stores/geodataStore.svelte.js';
	import { mapExtentStore } from '#lib/stores/mapExtentStore.svelte.js';
	import { EInterventions, ESafeCurvesModule, type ISafeCurvesSystemLayers } from '../interfaces';
	import { safeCurvesSpriteSheetPath } from '../loadMapSprites';
	import { disableByZoom } from '../../legendHelpers';

	const systemIds: string[] = [
		EInterventions.ExistingSigns,
		EInterventions.ExistingSpeedPlaques,
		EInterventions.ExistingChevronAreas
	];

	const available = $derived(
		(geodataStore.systemData as ISafeCurvesSystemLayers)[ESafeCurvesModule.Interventions]?.[
			EInterventions.ExistingSigns
		] != null
	);
	const legends = $derived(legendStore.layers.filter((l) => systemIds.includes(l.systemId)));
	const signs = $derived(legends.find((l) => l.systemId === EInterventions.ExistingSigns));

	function toggle(enabled: boolean) {
		for (const l of legends)
			legendStore.setAllLegendLayerVisibility({ layerId: l.layerId, enabled });
	}
</script>

{#if !available || !signs}
	<DataNotAvailable />
{:else}
	<LegendItems
		legend={signs}
		labels={{ 'Existing sign': 'Existing signs and plaques' }}
		selectAll={false}
		disabled={disableByZoom(signs.minzoom, mapExtentStore.zoom)}
		ontoggle={(_, enabled) => toggle(enabled)}>
		{#snippet patch()}
			<LegendIcon>
				<SpriteIcon icon="advisory_sign_W1-1L" spritePath={safeCurvesSpriteSheetPath()} size={30} />
			</LegendIcon>
		{/snippet}
	</LegendItems>
{/if}
